import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/customerservice');

export const releaseNotesApiPaths = {
  list: withRoot('/release-notes'),
  byId: withRoot('/release-notes/:releaseNoteId'),
} as const;

export const getReleaseNotesApiUrl = {
  list: () => releaseNotesApiPaths.list,
  byId: (releaseNoteId: string) => replacePathParams(releaseNotesApiPaths.byId, { releaseNoteId }),
};
